import React, { Component, Fragment } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import http from "../../http";
import { LanguageMenuList } from "./LabelList/LanguageMenuList";
import LanguageList from "./LanguageList";
import {
  DKButton,
  DKLabel,
  showLoader,
  removeLoader,
  DKIcon,
  DKIcons,
  showToast,
  TOAST_TYPE
} from "deskera-ui-library";
import UserManager from "../../managers/UserManager";
import AppManager from "../../managers/AppManager";
import OrgList from "../common/OrgList";
import Tenant from "../../services/tenant";
import TenantManager from "../../managers/TenantManager";
import AddOrgPopup from "../common/AddOrgPopup";
import ApiConstants from "../../constants/ApiConstants";
import NotificationPopup from "../notification/NotificationPopup";
import AddNewList from "./AddNewList";
import ProfileOptionsSection from "./ProfileOptionsSection";
import ic_profile_pic from "../../assets/menu/ic_profile_pic.png";
import NotificationService, {
  NotificationsUpdate,
} from "../../services/NotificationService";
import NotificationManager from "../../managers/NotificationManager";
import { ADMIN } from "../../managers/common/RouteAuth";
import {
  isMobileBrowser,
  isMobileWebView,
  isViewportLarge,
} from "../../utility/ViewportSizeUtils";
import SideBarService from "../../services/sidebar";
import InitialApiManager from "../../managers/InitialApiManager";
import Utility from "../../utility/Utility";
import { MOBILE_APP_ACTIONS } from "../../constants/Constant";
import SubscriptionAlert from "../subscription/SubscriptionAlert";
import { AUTHORIZATION_STATUS, PLANS } from "../../constants/Enum";
import { commonCustomEvent, COMMON_EVENTS } from "../../services/event/commonEvents";
import IAM from "../../services/iam";

import ic_startup from "../../assets/pricingSection/startup.svg";
import ic_essential from "../../assets/pricingSection/essential.svg";
import ic_professional from "../../assets/pricingSection/professional.svg";
import SetupOrganization from "../SetupOrganization";
import MaskUnmaskButton from "../../SharedComponents/MaskInput/MaskUnmaskButton";
import MaskInputUtil from "../../SharedComponents/MaskInput/MaskInputUtil";

import ApiManager from "../../managers/ApiManager";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { LeftMenuUpdate } from "./LeftMenuService";
import { isModuleRestricted, MODULE_ACCESS } from "../module-access-control/ModuleAccessControlConstants";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

/*
- isOrgAvailable
*/

class TopMenu extends Component {
  constructor(props) {
    const defaultLanguage = LanguageMenuList.find(
        (lang) => lang.code === props.defaultLangCode
    );

    super(props);
    this.state = {
      needOrgListPicker: false,
      allOrgs: [],
      tenantIds: [],
      allTenantsReceived: false,
      orgBtnTapped: false,
      needNotificationPopup: false,
      needAddNewList: false,
      needLanguageList: false,
      selectedFlag: defaultLanguage,
      newNotification: false,
      planName: "",
      isDesktop: isViewportLarge(),
      subscriptionData: null,
      showCountrySelect: false,
      showMaskUnmaskButton: false,
      mask: true
    };

    this.showMaskUnmaskButtonObservable = MaskInputUtil.subscripeToShowMaskUnmaskButtonObservable().subscribe(
      (show) => {
        setTimeout(() => {
          this.setState({
            showMaskUnmaskButton: show 
          });
        })
      }
    );
  }

  componentDidMount() {
    if (!isMobileWebView()) {
    this.onWindowFocussed();
    AppManager.handleWindowFocusListeners(this.onWindowFocussed, true);
    } else {
      this.onMobileWindowFocussed()
      AppManager.handleWindowFocusListeners(this.onMobileWindowFocussed, true);
    }
    Tenant.getAllTenants()
      .then((res) => {
        let orgNames = [],
          ids = [];
        let orgs = TenantManager.getAllTenants();
        for (let index = 0; index < orgs.length; index++) {
          orgNames.push(orgs[index].tenantName);
          ids.push(orgs[index].tenantId);
        }

        this.setState(
          {
            allOrgs: orgNames,
            tenantIds: ids,
            allTenantResReceived: true,
          },
          () => {
            if (this.state.orgBtnTapped) {
              this.showListPicker();
              removeLoader();
            }
          }
        );
      })
      .catch((err) => {});
      InitialApiManager.getPeopleSubscription().then(
        (response) => {
            if (response) {
                if (response['InTrial'] ) {
                  this.setState({ planName:  '1 month FREE trial'})
                } else if (!response['InTrial'] && response['Subscribed']) {
                  this.setState({ planName: response['PlanName'] })
                } else {
                  this.setState({ planName:  '1 month FREE trial'})
                }
            } else {
              this.setState({ planName:  '1 month FREE trial'})
            }
        }
    );
    document.addEventListener("mousedown", this.handleClickOutside);
    window.addEventListener("resize", this.windowSizeUpdated);
    this.subscription = NotificationsUpdate.getMessage().subscribe(message => {
      this.getUnreadNotification();
  });
  }

  windowSizeUpdated = () => {
    this.setState({
      isDesktop: isViewportLarge(),
    });
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.hideListPicker();
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("resize", this.windowSizeUpdated);
    this.subscription.unsubscribe();
    if (!isMobileWebView()) {
      AppManager.handleWindowFocusListeners(this.onWindowFocussed, false);
    } else {
      AppManager.handleWindowFocusListeners(this.onMobileWindowFocussed, false);
    }

    MaskInputUtil.unsubscribe(this.showMaskUnmaskButtonObservable);
  }

  getProfileSection() {
    return (
      <div className=" position-relative ml-m">
        <div
          className="cursor-hand"
          onClick={() => {
            this.setState({ needProfileOptionsSection: true });
          }}
          style={{ opacity: 0.6 }}
        >
          <DKIcon src={ic_profile_pic} className="circle ic-r-3" />
        </div>

        {this.state.needProfileOptionsSection &&
          this.getProfileOptionsSection()}
      </div>
    );
  }
  getProfileOptionsSection() {
    return (
      <ProfileOptionsSection
        onClose={() => {
          this.setState({ needProfileOptionsSection: false });
        }}
        accessedBy={this.props.accessedBy}
      />
    );
  }
  onSubcritionClose() {
    this.setState({
      subscriptionData: null,
      showCountrySelect: true
    });
  }
  isOrganisationSetup() {
    return (
      <>{!this.props.isOrgSetupCompleted && <SetupOrganization
      onComplete={() => {
        this.setState({
          showCountrySelect: false
        });
      }}
    />}</>
    )
  }
  getSubscriptionAlert() {
    return ((!AppManager.isBeforeUnload) && (this.state.subscriptionData?.needAlert) )? (
      <SubscriptionAlert
        customMessage={this.state.subscriptionData.customMessage || ""}
        onClose={() => {
          this.onSubcritionClose()
        }}
      />
    ) : null;
  }
  onMobileWindowFocussed = (e) => {
    IAM.checkIfUserSubscribed()
      .then(
        (res) => {
          const planDetails = UserManager.getUserPlanDetails()
          if (!planDetails['InTrial'] && planDetails['Subscribed']) {
            TenantService.set(TENANT.PLAN_NAME, planDetails['PlanName']);
          }
        }
      );
  }
  onWindowFocussed = (e) => {
    if (isMobileWebView()) {
      this.onMobileWindowFocussed()
      return;
    }
    if (document.hidden) return
    // Note: Need use in future
    // if (document.hidden || !AppManager.needSubscriptionApiCall) return;

    commonCustomEvent.dispatch(COMMON_EVENTS.SUBSCRIPTION_CHECK, {
      status: AUTHORIZATION_STATUS.PENDING,
    });

    IAM.checkIfUserSubscribed()
      .then(
        (res) => {
          const planDetails = UserManager.getUserPlanDetails()
          if (!planDetails['InTrial'] && planDetails['Subscribed']) {
            TenantService.set(TENANT.PLAN_NAME,planDetails['PlanName']);
          }
          /* Calling once on focus Only */
          AppManager.needSubscriptionApiCall = false;

          /* For triggering Top menu Rerender in case alert not opened,
          If Subscription alert already opened, 
          updated message will get showcased through custom event  */
          if (!this.state.subscriptionData?.needAlert) {
            this.setState({
              subscriptionData: null,
            });
          }

          commonCustomEvent.dispatch(COMMON_EVENTS.SUBSCRIPTION_CHECK, {
            status: AUTHORIZATION_STATUS.AUTHORIZED,
          });
        },
        (data) => {
          /* Need to Show Subscription alert */
          if (data && data.Status == "active") {
            this.setState({
              subscriptionData: {
                customMessage: "",
                needAlert: true,
              },
            });
      
            AppManager.needSubscriptionApiCall = true;
      
            commonCustomEvent.dispatch(COMMON_EVENTS.SUBSCRIPTION_CHECK, {
              status: AUTHORIZATION_STATUS.DENIED,
            });
          } else {
            AppManager.needSubscriptionApiCall = true;
            commonCustomEvent.dispatch(COMMON_EVENTS.SUBSCRIPTION_CHECK, {
              status: AUTHORIZATION_STATUS.DENIED,
            });
            this.handleSubscriptionPopup()
          }
        }
      )
      .catch((err) => {
        AppManager.needSubscriptionApiCall = true;
        commonCustomEvent.dispatch(COMMON_EVENTS.SUBSCRIPTION_CHECK, {
          status: AUTHORIZATION_STATUS.DENIED,
        });
      });
  };
  handleSubscriptionPopup = () => {

    ApiManager.checkIfUserLoggedIn(
      (data) => {
        console.log(data)
      },
      () => { 
        AppManager.gotoLoginPage(); 
      })

  }
  render() {
    const { isDesktop } = this.state;
    const isNotificationUrl = window.location.href.split("/").pop() === "notifications";
    return (<>
        <div className="parent-width bg-white row justify-content-between p-h-r p-v-s shadow-s z-index-3 flex-shrink-0">
          <div
              className="dk-sidebar-menu-toggle p-v-s expandable-menu-button cursor-hand z-index-4 column justify-content-center display-only-mobile"
              onClick={() => SideBarService.toggleSideBar()}
          >
            <div className="row">
                <DKIcon src={DKIcons.ic_menu} className={`ic-s shadow-s-2`} />
                {isMobileWebView() && this.getTenantNameView()}
            </div>
          </div>
          <div className="row width-auto">{this.getNoCardView()}</div>
        {this.state.needOrgListPicker && this.renderListPicker()}
        {this.state.showAddNewOrgPopup && this.showAddNewOrgPopup()}
          <div className="row width-auto">
            {ApiConstants.DESKERA_APP_LINK_ENABLED && isMobileBrowser() && (
              <div className="p-h-m">
                <DKButton
                  title="Open Deskera App"
                  className={"bg-button text-white"}
                  onClick={() => {
                    this.openDeskeraApp();
                  }}
                />
              </div>
            )}
            {this.state.showMaskUnmaskButton && this.getMaskUnmaskButton()}
            {isMobileWebView() && this.getMobileAppActions()}
            <div className="position-relative">
              {!isMobileWebView() && this.isShowCreatNewButton() && this.props.accessedBy === ADMIN && <DKButton
                  icon={DKIcons.white.ic_add}
                  title={isDesktop ? "Create New" : ""}
                  className={`bg-button text-white ml-m ${
                      isDesktop ? "" : "circle"
                  }`}
                onClick={this.toggleAddNewList}
              />}
              {this.state.needAddNewList && (
                <div
                  className="transparent-background"
                  onClick={() => this.hideAddNewList()}
                />
              )}
              {this.state.needAddNewList && this.getAddNewList()}
            </div>
            <div className="position-relative ml-m">
              {<>{!isMobileWebView() && <DKButton
                icon={DKIcons.ic_notification}
                className="bg-gray2 border-radius-l "
                onClick={() => {
                  this.showNotificationPopup(isNotificationUrl);
                }}
              />}

              {!isMobileWebView() && this.state.newNotification && <div
                className="bg-red circle position-absolute p-xs"
                style={{ top: -1, right: 1, backgroundColor: "red" }}
              /> }
              </>}
              {this.state.needNotificationPopup && (
                <div
                  className="transparent-background"
                  onClick={this.hideNotificationPopup}
                />
              )}
              {this.state.needNotificationPopup && !isNotificationUrl && this.getNotificationPopup()}
            </div>
          {!isMobileWebView()&&<div className="position-relative ml-m">
            <div
              onClick={this.toggleLanguageList}
              className="flex items-center cursor-pointer"
              style={{ width: 30, height: 30 }}
              id="language-list-popup-btn"
            >
              <DKIcon src={this.state.selectedFlag.icon} className="circle" style={{ height: 28, width: 28 }} />{" "}
              <p
                className="mr-m font-semibold"
                style={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              ></p>
            </div>
            {this.state.needLanguageList && this.getLanguageList()}
          </div>}
            {!isMobileWebView() && this.getProfileSection()}
          </div>
      </div>
      {this.isOrganisationSetup()}
      {!isMobileWebView() && this.getSubscriptionAlert()}
      </>
    );
  }

  isShowCreatNewButton() {
    return !isModuleRestricted(this.props.moduleAccessControl, MODULE_ACCESS.HIRING) &&
      (PermissionUtils.hasAccess(MODULE.CANDIDATE, [ACTION.VIEW]) ||
      PermissionUtils.hasAccess(MODULE.JOB_PIPELINE, [ACTION.VIEW]) ||
      PermissionUtils.hasAccess(MODULE.JOB_FORM, [ACTION.VIEW]))
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getAddNewList() {
    return <AddNewList onClose={() => this.hideAddNewList()} />;
  }

  toggleAddNewList = () => {
    this.setState({
      needAddNewList: !this.state.needAddNewList,
    });
  };

  hideAddNewList = () => {
    this.setState({
      needAddNewList: false,
    });
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

    getLanguageList = () => {
        return (
            <LanguageList
                onSelect={this.changeLanguageSelection}
                onClose={this.hideLanguageList}
            />
        );
    };

    changeLanguageSelection = (selected) => {
        this.setState({
            selectedFlag: selected,
            needLanguageList: false
        });

        LeftMenuUpdate.sendMessage(true);
    };

    toggleLanguageList = () => {
        this.setState({
            needLanguageList: !this.state.needLanguageList,
        });
    };

    hideLanguageList = () => {
        this.setState({
            needLanguageList: false,
        });
    };

  getNoCardView() {
    let helloKeywords = [
      "Hi",
      "Hello",
      "Hey",
      "Hola",
      "Bonjour",
      "Salve",
      "Nǐn hǎo",
      "Namaste",
    ];
    let hey = helloKeywords[Math.floor(Math.random() * helloKeywords.length)];
    
    let message = `<span style="font-size: 16px">👋</span> Welcome <b>${UserManager.getUserName()}</b>`;
    
    const userPlan = {
      name: "",
      icon: "",
      inTrial: UserManager.isTrialPlanActive(),
      isActive: UserManager.isPlanActive(),
      trialDays: 0,
    };

    if (userPlan.inTrial) {
      userPlan.trialDays = UserManager.getTrialDays(true);
    } else if (userPlan.isActive) {
      userPlan.name = UserManager.getUserPlanName();
      userPlan.icon = this.getPlanIcon(userPlan.name);
    }
    
    return (
      <div
        className=" display-only-web bg-deskera-secondarys border-ss p-h-s border-radius-m"
      >
        <div className="row align-items-center ">
        { (
            <>
              <DKLabel text={"👋"} className="fs-l" />
              <DKLabel text={" Welcome "} />
              <DKLabel
                text={UserManager.getUserName()}
                className="fw-b"
              />
            </>
          )}
          {userPlan.inTrial ? (
            <Fragment>
              <DKLabel
                text={`, Your trial will end ${
                  userPlan.trialDays ? `in ${userPlan.trialDays} days` : `today`
                }, `}
                className="fw-m text-red"
               
              />
              <DKButton
                title={`subscribe now`}
                className="fw-m text-blue text-underline"
                style={{ paddingLeft: 3, paddingRight: 5 }}
                onClick={() => {
                  AppManager.needSubscriptionApiCall = true;
                  window.open(ApiConstants.PRODUCT_URL_GO + "billing");
                }}
              />
            </Fragment>
          ) : userPlan.name ? (
            <Fragment>
              <DKLabel
                text=", you are on "
                
              />
              <DKButton
                title={`${userPlan.name} Plan`}
                className="fw-m text-blue text-underline"
                style={{ padding: "0 2px" }}
                onClick={() => {
                  AppManager.needSubscriptionApiCall = true;
                  window.open(ApiConstants.PRODUCT_URL_GO + "billing");
                }}
              />
              <DKIcon src={userPlan.icon} className="ic-s-2 pl-xs pb-xxs" />
              <DKLabel
                text={this.getPlanBadgeStatus(userPlan.isActive)}
                className={`${
                  userPlan.isActive
                    ? "bg-chip-green border-green text-green"
                    : "bg-chip-red border-red text-red"
                } fw-m border-radius-r ml-s p-h-s`}
              />
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }
  getPlanIcon(planName = "") {
    let iconSrc = null;
    switch (planName.toLowerCase()) {
      case PLANS.STARTUP:
        iconSrc = ic_startup;
        break;
      case PLANS.ESSENTIAL:
        iconSrc = ic_essential;
        break;
      case PLANS.PROFESSIONAL:
        iconSrc = ic_professional;
        break;
      default:
    }

    return iconSrc;
  }
  getPlanBadgeStatus(isPlanActive) {
    return isPlanActive ? "Active" : "Expired";
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  addOrgTapped = () => {
    this.setState({
      showAddNewOrgPopup: true,
    });
  };

  cancelTapped = () => {
    this.setState({
      showAddNewOrgPopup: false,
    });
  };

  showAddNewOrgPopup = () => {
    return <AddOrgPopup onCancel={this.cancelTapped} />;
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  renderListPicker() {
    const { allOrgs, tenantIds } = this.state;
    return (
      <div
        ref={this.setWrapperRef}
        className="position-absolute"
        style={{ top: 52, left: 15 }}
      >
        <OrgList
          allOrgs={allOrgs}
          tenantIds={tenantIds}
          onAddOrgClick={this.addOrgTapped}
          onClose={this.hideListPicker}
        />
      </div>
    );
  }

  toggleListPicker = () => {
    this.setState({ orgBtnTapped: true });
    if (!this.state.allTenantResReceived) {
      showLoader("Fetching organisations...");
      return;
    }
    this.setState({
      needOrgListPicker: !this.state.needOrgListPicker,
    });
  };
  showListPicker = () => {
    this.setState({
      needOrgListPicker: true,
    });
  };
  hideListPicker = () => {
    this.setState({
      needOrgListPicker: false,
    });
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  settingsTapped = () => {
    RouteManager.navigateToPage(PAGE_ROUTES.SETTINGS);
  };

  logoutTapped = () => {
    AppManager.logout();
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getNotificationPopup = () => {
    return (
        <div
            id="notification-section"
            className="position-absolute bg-white pl-m pr-m pb-xl pt-s border-radius-s shadow-m border-m"
            style={{ top: 36, right: 0, width: 330, zIndex: 9999 }}
        >
            <NotificationPopup onClose={this.hideNotificationPopup} />
        </div>
    );
  };

  showNotificationPopup = (isNotificationUrl) => {
    this.setState({ needNotificationPopup: !isNotificationUrl });
  };

  hideNotificationPopup = () => {
    this.setState({ needNotificationPopup: false });
  };

  getUnreadNotification = () => {
    NotificationService.getNotifications()
    .then(response=>{
      if(response && response['data']) {
        let notifications = response['data'];
        if(notifications) {
          let newNotification = false;
          notifications = NotificationManager.processBeforeDislay(notifications)
          notifications.forEach(notification=>{
            if(notification.status != "read") {
              newNotification = true;
            }
          })
          this.setState({newNotification: newNotification})
        }
      }
    })
  }

  getTenantNameView() {
    return (
        <DKLabel className="fw-m fs-l pr-m pl-m" style={{
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          maxWidth: "160px"
        }} text={UserManager.getUserTenantName()}/>
    )
  }

  getMaskUnmaskButton() {
    return (
      <MaskUnmaskButton
        mask={this.state.mask}
        onClick={() => {
          this.setState({
            mask: !this.state.mask
          }, () => {
            MaskInputUtil.updateMaskUnmaskStatus(this.state.mask);
          });
        }}
      />
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getMobileAppActions() {
    return (
        <div className="row position-relative ml-m">
          <DKButton
              icon={DKIcons.white.ic_home}
              className={'bg-button text-white circle'}
              onClick={() => Utility.postMobileAppActions(MOBILE_APP_ACTIONS.HOME)}
          />
        </div>
    );
  }

  async openDeskeraApp() {
    showLoader("Opening Deskera app...");
    try {
      const payload = {
        refreshToken: "eyJjdHkiOiJKV1QiLCJlbmMiOiJ",
        tenantId: -1,
        userName: "lywepumu@deskera.com",
      };
      const response = await http.post(ApiConstants.URL.IAM.SSO_REFRESH_TOKEN, payload);
      if (response) {
        const { idToken, accessToken, refreshToken } = response;
			  window.location.href = `deskeraApp://signin?idToken=${idToken}&accessToken=${accessToken}&refreshToken=${refreshToken}`;
      }
      removeLoader();
    } catch(error) {
      removeLoader();
      showToast("Failed to start Deskera App session, Please try again after re-logging.", TOAST_TYPE.FAILURE);
      console.log(error);
    }
  }
}

const mapStateToProps = (state) => ({
  moduleAccessControl: state.moduleAccessControl?.data
});

export default connect(mapStateToProps)(withTranslation()(TopMenu));
